import { RevisionType } from '@common/services/revision';

export const REVISION_TYPE_COLORS: Record<RevisionType, string> = {
  [RevisionType.ADD]: 'green',
  [RevisionType.MOD]: 'blue',
  [RevisionType.DEL]: 'red',
};